import React, { useState, useEffect } from "react";
import { EditBlock, EditBlockOption } from "../EditBlock";
import { Col, Row } from "antd";
import style from "./EditZhuguan.module.scss";
import { QuestionType } from "../../../../../service/service";
import { TopicType } from "../../../../../service/homework";
import Editor from "../../../../../components/Editor";

interface EditZhuguanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditZhuguan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditZhuguanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.ZhuGuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditZhuguanPure
                innerTopic={innerTopic}
                setInnerTopic={setInnerTopic}
            />
        </EditBlock>
    );
}

export interface EditZhuguanPureProps {
    innerTopic: any;
    setInnerTopic: any;
}

export function EditZhuguanPure({
    innerTopic,
    setInnerTopic
}: EditZhuguanPureProps) {
    return (
        <React.Fragment>
            <Row>
                <Col span={3} className={style.label}>
                    要求：
                </Col>

                <Col span={20}>
                    <Editor
                        data={innerTopic.contentText}
                        onChange={text =>
                            setInnerTopic({ ...innerTopic, contentText: text })
                        }
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
}
